/**
 * The way back, the same on every screen.
 *
 * There used to be four of them. The statistics and the photo screen had
 * „‹ Übersicht" at the top left, writing had the logo — which does go back
 * but does not look like it — and the exercise had a ✕ at the top RIGHT,
 * because it was built as a dialog. Four screens, four things to learn.
 *
 * Now there is one: a quiet line at the top left that says where it leads.
 * Whoever has found it once has found it everywhere, and the browser's own
 * back button does the same thing beside it.
 *
 * Quiet on purpose — grey, no frame, small. It is the way out of a screen,
 * not an offer; what the screen is for stands below it.
 */

import { Icon } from './icons.js'
import * as st from '../state.js'

export function PageBack({
  onBack,
  label = 'Übersicht',
  children,
}: {
  /** Where back leads. Left out, it is the start screen. */
  onBack?: () => void
  /** What lies back there. „Übersicht" unless a screen says otherwise. */
  label?: string
  /** A title, for the screens that have one of their own. */
  children?: preact.ComponentChildren
}) {
  return (
    <header class="page-bar">
      <button
        type="button"
        class="page-back"
        onClick={onBack ?? (() => st.goTo('start'))}
      >
        <Icon name="chevron-left" size={17} />
        {label}
      </button>
      {children}
    </header>
  )
}
